import { fileService } from "@/shared/services";


export const saveMspCitas = async (dataDocumentos, nIdentificacion) => {


  let newUrlMspPaciente = null;
  let newUrlMspTitular1 = null;
  let newUrlMspTitular2 = null;
  let newUrlMspTitular3 = null;

  const filesCita = dataDocumentos;

  if(filesCita){

    if(filesCita?.mspPaciente){
      newUrlMspPaciente = await fileService.upload(
        'msp', 
        filesCita.mspPaciente,
        nIdentificacion,
        filesCita.urlMspPaciente
      );

    }

    if(filesCita?.mspPaciente === undefined){
      const deleteFile = await fileService.deleteFile(filesCita.urlMspPaciente);
      newUrlMspPaciente = deleteFile ? 'eliminado' : ''
    }


    if(filesCita?.mspTitular1){
      newUrlMspTitular1 = await fileService.upload(
        'msp', 
        filesCita.mspTitular1,
        nIdentificacion,
        filesCita.urlMspTitular1
      );
    }

    if(filesCita?.mspTitular1 === undefined){
      const deleteFile = await fileService.deleteFile(filesCita.urlMspTitular1);
      newUrlMspTitular1 = deleteFile ? 'eliminado' : ''
    }

    if(filesCita?.mspTitular2){
      newUrlMspTitular2 = await fileService.upload(
        'msp', 
        filesCita.mspTitular2,
        nIdentificacion,
        filesCita.urlMspTitular2
      );
    }

    if(filesCita?.mspTitular2 === undefined){
      const deleteFile = await fileService.deleteFile(filesCita.urlMspTitular2);
      newUrlMspTitular2 = deleteFile ? 'eliminado' : ''
    }


    if(filesCita?.mspTitular3){
      newUrlMspTitular3 = await fileService.upload(
        'msp', 
        filesCita.mspTitular3,
        nIdentificacion,
        filesCita.urlMspTitular3
      );
    }

    if(filesCita?.mspTitular3 === undefined){
      const deleteFile = await fileService.deleteFile(filesCita.urlMspTitular3);
      newUrlMspTitular3 = deleteFile ? 'eliminado' : ''
    }

  } 

  const variables = {
    urlMspPaciente  : newUrlMspPaciente   || "",
    urlMspTitular1  : newUrlMspTitular1   || "",
    urlMspTitular2  : newUrlMspTitular2   || "",
    urlMspTitular3  : newUrlMspTitular3   || "",
  }

  console.log("variables", variables)
  
  return variables
}